// extracted by mini-css-extract-plugin
module.exports = {"grid":"judge-dark-head_grid__w3mpy","glow":"judge-dark-head_glow__wegNa"};